import { Component, OnChanges, SimpleChanges, Input, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Product } from 'src/app/modules/warehouse/modules/product/interfaces/product';
import { CustomValidators } from '../../validators/custom-validators';
import {getBrutto} from '../../../../shared/functions/get-brutto';
import { Item } from 'src/app/modules/order/interface/item';

@Component({
  selector: 'item-form',
  templateUrl: './item-form.component.html',
  styleUrls: ['./item-form.component.css']
})
export class ItemFormComponent implements OnChanges {

  getBrutto = getBrutto;

  @Input()
  public product: Product;

  @Input()
  public item: Item = null;

  @Input()
  public type: string = null;

  public form: FormGroup;

  @Output()
  public updateEmitter = new EventEmitter<boolean>();

  constructor(public cd: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['product']) {
      if (this.product) {
        this.createForm();
      }
    }

    if (changes['item'] && this.item !== undefined && this.item !== null) {
      this.cd.markForCheck();
      this.updateEmitter.emit(true);
      this.setFormData();
    }
  }

  /**
   * Setzt das übergebene Item im Formular
   *
   * @param Item
   */
  public setItem = (item: Item) => {
    if (item.IdProduct === this.product.Id) {
      this.item = item;
    }
  }

  /**
   * Erstellt das Formular für die Anzahl mit den Standartwerten des Items
   */
  private createForm = () => {
    this.form = new FormGroup({
      IdProduct: new FormControl(this.product.Id),
      Type: new FormControl(this.type),
      Quantity: new FormControl(0, [CustomValidators.positive])
    });
  }

  private setFormData = () => {
    if (this.item !== null && this.item !== undefined) {
      this.form.patchValue({
        Quantity: this.item.Quantity
      });
    }
  }

  /**
   * Gibt die Brutto-Summe eines Items aus
   *
   * @return number
   */
  public getProductPrice = () => {
    if (this.product.IsComplimentary) {
      return 0;
    }
    
    const quantity = this.form.controls.Quantity.value;
    return this.getBrutto(this.product) * quantity;
  }

  /**
   * Gibt die daten aus dem Formular zurück
   *
   * @return any
   */
  public getProduct = () => {
    return this.form.value;
  }

  public update = () => {
    this.updateEmitter.emit(true);
  }
}
